<template>
    <div class="ptb-10 plr-20">
      <BudgetQuotation :titleName="titleName" :define="2"></BudgetQuotation>
    </div>
</template>
<script>
import BudgetQuotation from '../customer/budgetItem/budgetQuotation.vue'
export default {
  name: 'room-bag-define',
  components: {BudgetQuotation},
  data () {
    return {
      titleName: '房间包列表'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/roomBagDefine.vue